import { useMemo } from "react";
import useSearcherDiscountsInput from "../../../../../../hooks/common/searchers/inputs/useDiscountsInput.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
import { transformDiscountToValue } from "../../utils/select.js";
const useDiscountsInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading , discounts  } = state ?? {};
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    const discountsInputOptions = useMemo(()=>discounts?.map((discount)=>transformDiscountToValue(discount)), [
        discounts
    ]);
    return useSearcherDiscountsInput({
        label: literals?.discountsLabel ? literals?.discountsLabel : '',
        options: discountsInputOptions,
        defaultValue: defaultValues.discounts,
        disabled: isLoading,
        shouldUnregister: true
    });
};
export default useDiscountsInput;

//# sourceMappingURL=useDiscountsInput.js.map